export default __webpack_public_path__ + "static/media/commercial-active.0f1515c7.svg";